module.exports = __webpack_public_path__ + "static/img/封面照片.54f006e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/封面照片.png
// module id = /MrG
// module chunks = 7